<template>
  <div
    ref="panzoomContainer"
    class="panzoom-container font-aktiv-grotesk"
    style="background-color: #1a1a1a; overflow: hidden; position: relative"
  >
    <img
      ref="imageRef"
      id="image-id"
      :src="imageSrc"
      alt="image"
      style="width: 100%; height: auto; display: block; margin: 0 auto"
    />
    <transition name="fade">
      <div
        v-if="showHint"
        class="absolute inset-0 flex items-center justify-center"
        @click="dismissHint"
      >
        <div class="absolute inset-0 bg-black/40" />
        <div class="relative z-[1] flex items-center gap-2 bg-black/80 rounded-[20px] px-4 py-1">
          <img
            src="../../../public/assets/images/gic/orange-pinch-icon.svg"
            class="w-[32px] h-[32px]"
            alt="pinch-icon"
          />
          <span class="text-white text-[16px] leading-[16px] font-medium">Pinch to zoom</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import Panzoom from '@panzoom/panzoom';
import { isNativeNotWeb } from '@/utils/platform-check';

export default {
  name: 'ImageZoom',
  props: {
    imageSrc: {
      type: String,
      required: true,
    },
    maxScale: {
      type: Number,
      required: true,
      default: 3,
    },
    minScale: {
      type: Number,
      required: true,
      default: 1,
    },
  },
  setup(props) {
    const imageRef = ref(null);
    const panzoomContainer = ref(null);
    const showHint = ref(isNativeNotWeb());
    let panzoomInstance = null;

    function dismissHint() {
      showHint.value = false;
    }

    function startDismissTimer() {
      // Reset and show the hint when page is entered
      if (isNativeNotWeb()) {
        showHint.value = true;
        setTimeout(() => {
          dismissHint();
        }, 3000);
      }
    }

    function onTouchStart(e) {
      if (e.touches.length >= 2) dismissHint();
    }

    onMounted(() => {
      if (!isNativeNotWeb() || !imageRef.value || !panzoomContainer.value) return;

      if (imageRef.value && panzoomContainer.value) {
        panzoomInstance = Panzoom(imageRef.value, {
          maxScale: props.maxScale,
          minScale: props.minScale,
          contain: 'outside',
        });

        panzoomContainer.value.addEventListener('wheel', panzoomInstance.zoomWithWheel);
        panzoomContainer.value.addEventListener('touchstart', onTouchStart);
      }
    });

    onBeforeUnmount(() => {
      if (panzoomInstance && panzoomContainer.value) {
        panzoomContainer.value.removeEventListener('wheel', panzoomInstance.zoomWithWheel);
        panzoomContainer.value.removeEventListener('touchstart', onTouchStart);
        panzoomInstance.destroy();
      }
    });

    return {
      imageRef,
      panzoomContainer,
      showHint,
      dismissHint,
      startDismissTimer,
    };
  },
};
</script>

<style scoped>
.panzoom-container {
  touch-action: none;
  -webkit-user-select: none;
  user-select: none;
  overflow: hidden;
}

.panzoom-container img {
  cursor: grab;
}

.panzoom-container img:active {
  cursor: grabbing;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
